import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  private readonly options = { withCredentials: true };

  constructor(private _http:HttpClient) { }

  public get(url:string):Observable<any>{
    return this._http.get(environment.baseUrl+url, this.options);
  }

  public getBlob(url:string):Observable<Blob>{
    return this._http.get(environment.baseUrl+url, { ...this.options, responseType: 'blob' });
  }

  public post(url:string, body:any):Observable<any>{
    return this._http.post(environment.baseUrl+url, this._convertDates(body), this.options);
  }
  public patch(url:string,id:any, body:any):Observable<any>{
    return this._http.patch(environment.baseUrl+url+id, this._convertDates(body), this.options);
  }
  public put(url:string,id:any, body:any):Observable<any>{
    return this._http.put(environment.baseUrl+url+id, this._convertDates(body), this.options);
  }
  public delete(url:string, id:any):Observable<any>{
    return this._http.delete(environment.baseUrl+url+id, this.options);
  }
  /** Walks the body and replaces every Date (or moment) value with its ISO string. */
  private _convertDates(body:any): any{
    if(body === null || body === undefined) return body;

    if(body instanceof Date) return isNaN(body.getTime()) ? null : body.toISOString();

    // moment objects, without importing moment here
    if(typeof body === 'object' && body._isAMomentObject && typeof body.toISOString === 'function'){
      return body.isValid() ? body.toISOString() : null;
    }

    // binary / browser payloads must be sent as-is
    if(body instanceof FormData || body instanceof Blob || body instanceof File
      || body instanceof ArrayBuffer || ArrayBuffer.isView(body)) return body;

    if(Array.isArray(body)) return body.map(item => this._convertDates(item));

    // plain objects only — leave class instances untouched
    if(typeof body === 'object' && (Object.getPrototypeOf(body) === Object.prototype || Object.getPrototypeOf(body) === null)){
      const converted:any = {};
      for(const key of Object.keys(body)) converted[key] = this._convertDates(body[key]);
      return converted;
    }

    return body;
  }
}
